import '../assents/styles/components/About.scss';
import DonwloadCv from './DonwloadCv';

function About() {
  return (
    <div className="about">
      <section className="intro">
        <h2>Hi! I'm Denis Sanchez</h2>
        <p>
          A passionate tech enthusiast since childhood, always seeking to collaborate on exciting projects. I am not afraid of hard work.
        </p>
        <p>
          I’m a creative, responsible, and self-taught Front-End Developer with experience in HTML, CSS, JavaScript, and React.
        </p>
      </section>

      <section className="skills">
        <h3>Frontend Skills</h3>
        <ul className='about--ul'>
          <li>HTML5</li>
          <li>CSS / Sass / Bootstrap</li>
          <li>JavaScript (ES5 - ES6)</li>
          <li>React / Redux / React-Router</li>
          <li>Bitbucket / Jira</li>
          <li>REST API</li>
          <li>Git / GitHub</li>
        </ul>

        <h3>Backend Skills</h3>
        <ul  className='about--ul'>
          <li>ASP.NET (C#)</li>
          <li>SQL Server</li>
        </ul>
      </section>

      <section className="contact">
        <h3>Contact & Networks</h3>
        <ul className='about--ul'>
          <li>Email: <a href="mailto:contact.denis.sanchez@gmail.com">contact.denis.sanchez@gmail.com</a></li>
          <li>GitHub: <a href="https://github.com/DenisV2112" target="_blank">github.com/DenisV2112</a></li>
          <li>Codewars: <a href="https://www.codewars.com/users/DenisV2103" target="_blank">codewars.com/users/DenisV2103</a></li>
        </ul>
      </section>
      <DonwloadCv />
    </div>
  );
}

export default About;
